import { Link } from "react-router-dom";

export default function Impressum() {
  return (
    <div className="pt-20 md:pt-24 bg-white min-h-screen">
      <section className="section-gap border-b border-hb-border bg-hb-off-white">
        <div className="container-hb">
          <span className="label-text text-hb-wood block mb-4">Rechtliches</span>
          <h1 className="section-title max-w-2xl">Impressum</h1>
          <p className="text-sm text-hb-muted font-inter mt-3">Stand: März {new Date().getFullYear()}</p>
        </div>
      </section>

      <section className="section-gap">
        <div className="container-hb max-w-3xl">
          <div className="prose-hb space-y-10">

            <div>
              <h2 className="text-lg font-manrope font-bold text-hb-dark mb-4 border-b border-hb-border pb-3">
                Anbieter dieser Website
              </h2>
              <p className="text-xs text-hb-muted font-inter mb-4">
                Gemäß Art. 1 D.Lgs. 70/2003 (Gesetz über elektronischen Geschäftsverkehr, Italien)
                sowie EU-Richtlinie 2000/31/EG
              </p>
              <div className="space-y-2 text-sm text-hb-text font-inter leading-relaxed">
                <p className="font-semibold text-hb-dark text-base">Hafner EC GmbH</p>
                <p className="italic text-hb-muted text-xs mb-2">Betrieb der Marke Holzbuddy</p>
                <p>Sinich-Bach-Str. 60 (Via Rio di Sinigo, 60)<br />I-39012 Meran (Merano) BZ<br />Südtirol (Alto Adige), Italien</p>
                <p>
                  <span className="text-hb-muted">Telefon:</span>{" "}
                  <a href="tel:+390473238030" className="text-hb-dark hover:text-hb-wood transition-colors">+39 0473 238 030</a>
                </p>
                <p>
                  <span className="text-hb-muted">E-Mail:</span>{" "}
                  <a href="mailto:info@holzbuddy.team" className="text-hb-dark hover:text-hb-wood transition-colors">info@holzbuddy.team</a>
                </p>
                <p>
                  <span className="text-hb-muted">Website:</span>{" "}
                  <a href="https://www.hafner-ec.com" target="_blank" rel="noopener noreferrer" className="text-hb-dark hover:text-hb-wood transition-colors">www.hafner-ec.com</a>
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-lg font-manrope font-bold text-hb-dark mb-4 border-b border-hb-border pb-3">
                Unternehmensangaben (Dati societari)
              </h2>
              <div className="space-y-2 text-sm text-hb-text font-inter leading-relaxed">
                <p><span className="text-hb-muted">Rechtsform / Forma giuridica:</span> GmbH / S.r.l. (Gesellschaft mit beschränkter Haftung)</p>
                <p><span className="text-hb-muted">MwSt.-Nr. / Partita IVA:</span> IT02706840218</p>
                <p><span className="text-hb-muted">Steuernummer / Codice Fiscale:</span> 02706840218</p>
                <p><span className="text-hb-muted">Handelskammer Bozen / REA:</span> BZ-182345</p>
                <p><span className="text-hb-muted">Stammkapital / Capitale sociale:</span> Vollständig eingezahlt (voll verstoßen)</p>
                <p><span className="text-hb-muted">Gesellschaftssitz / Sede legale:</span> Sinich-Bach-Str. 60, I-39012 Meran (BZ)</p>
              </div>
            </div>

            <div>
              <h2 className="text-lg font-manrope font-bold text-hb-dark mb-4 border-b border-hb-border pb-3">
                Verantwortlich für den Inhalt (Responsabile dei contenuti)
              </h2>
              <div className="space-y-2 text-sm text-hb-text font-inter leading-relaxed">
                <p><span className="text-hb-muted">Person:</span> <strong className="text-hb-dark">Jonas Hafner</strong></p>
                <p><span className="text-hb-muted">Funktion:</span> Geschäftsführer (Amministratore Delegato)</p>
                <p>Sinich-Bach-Str. 60 · I-39012 Meran (BZ)</p>
              </div>
            </div>

            <div>
              <h2 className="text-lg font-manrope font-bold text-hb-dark mb-4 border-b border-hb-border pb-3">
                Berufsrechtliche Regelungen
              </h2>
              <div className="space-y-2 text-sm text-hb-text font-inter leading-relaxed">
                <p>
                  Die Hafner EC GmbH ist im Handwerksverzeichnis der Autonomen Provinz Bozen-Südtirol eingetragen
                  und unterliegt den berufsrechtlichen Vorschriften für das Baugewerbe in Italien.
                </p>
                <p>
                  <span className="text-hb-muted">Zuständige Aufsichtsbehörde:</span> Autonome Provinz Bozen-Südtirol, Amt für Handwerk<br />
                  <span className="text-hb-muted">Berufsbezeichnung / Qualifica:</span> Zimmerei und Holzbau / Falegnameria e costruzioni in legno<br />
                  <span className="text-hb-muted">Verleihungsstaat / Stato di rilascio:</span> Italia (Südtirol / Alto Adige)
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-lg font-manrope font-bold text-hb-dark mb-4 border-b border-hb-border pb-3">
                Haftungshinweis (Esclusione di responsabilità)
              </h2>
              <p className="text-sm text-hb-text font-inter leading-relaxed">
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
                Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
                Die auf dieser Website veröffentlichten Inhalte (Texte, Bilder, Grafiken) unterliegen dem
                Urheberrecht (Legge 633/1941 e s.m.i.). Eine Vervielfältigung, Bearbeitung oder anderweitige
                Nutzung ist ohne schriftliche Genehmigung der Hafner EC GmbH nicht gestattet.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-manrope font-bold text-hb-dark mb-4 border-b border-hb-border pb-3">
                Online-Streitbeilegung (Risoluzione alternativa delle controversie)
              </h2>
              <p className="text-sm text-hb-text font-inter leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-hb-wood hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>.{" "}
                Unsere E-Mail-Adresse lautet: info@holzbuddy.team.
                Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen (Art. 141-sexies Codice del Consumo).
              </p>
            </div>

            <div>
              <h2 className="text-lg font-manrope font-bold text-hb-dark mb-4 border-b border-hb-border pb-3">
                Aufsichtsbehörden (Autorità di vigilanza)
              </h2>
              <div className="space-y-3 text-sm text-hb-text font-inter leading-relaxed">
                <p>
                  <strong className="text-hb-dark">Datenschutz (Privacy):</strong><br />
                  Garante per la protezione dei dati personali · Piazza Venezia 11 · I-00187 Roma<br />
                  <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-hb-wood hover:underline">www.garanteprivacy.it</a>
                </p>
                <p>
                  <strong className="text-hb-dark">Handelskammer:</strong><br />
                  Camera di Commercio, Industria, Artigianato e Agricoltura di Bolzano<br />
                  Via Alto Adige 60 · I-39100 Bozen (BZ)<br />
                  <a href="https://www.camcom.bz.it" target="_blank" rel="noopener noreferrer" className="text-hb-wood hover:underline">www.camcom.bz.it</a>
                </p>
              </div>
            </div>

            <div className="pt-6 border-t border-hb-border">
              <Link to="/datenschutz" className="btn-link text-sm">
                Zur Datenschutzerklärung →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
